import Bowser from 'bowser';
import minimumBrowserVersion from '../../browserVersions.json';
import { logger } from '@lib/datadog';

interface IJSONBrowserData {
  name: string;
  version: number;
}

interface IParsedResult {
  browser: IDetails;
  os: IOSDetails;
  platform: IPlatformDetails;
  engine: IDetails;
}

interface IDetails {
  name?: string;
  version?: string;
}

interface IOSDetails extends IDetails {
  versionName?: string;
}

interface IPlatformDetails {
  type?: string;
  vendor?: string;
  model?: string;
}

export let browserNotSupported: boolean;

function checkBrowserSupport(): boolean {
  let browserDetails: IParsedResult;

  try {
    browserDetails = Bowser.parse(window.navigator.userAgent);
  } catch (error) {
    return false;
  }

  const platform: string = browserDetails?.platform?.type;
  const browserName: string = browserDetails?.browser?.name;
  const browserVersion: number = parseInt(browserDetails?.browser?.version, 10);
  let jsonBrowserData: IJSONBrowserData;

  if (platform == null || browserName == null || Number.isNaN(browserVersion)) return false;

  if (platform === 'desktop') {
    jsonBrowserData = minimumBrowserVersion.desktop?.[browserName];
  } else {
    jsonBrowserData = minimumBrowserVersion.mobile?.[browserName];
  }

  const minSupportedVersion = jsonBrowserData?.version;
  if (browserVersion < minSupportedVersion || jsonBrowserData === undefined) {
    logger.info(`Unsupported-Browser-access`);
    return true;
  }
  return false;
}

export function isBrowserNotSupported(): void {
  browserNotSupported = checkBrowserSupport();
}

